export enum CmTableTools {
	FILTER = 'filter-bar',
	TOGGLE_FILTER = 'filter-toggle-all-button',
	EMPTY_GROUPS = 'empty-groups',
	TOGGLE_GROUPS = 'empty-groups',
	ZOOM = 'zoom',
	FULLSCREEN = 'fullscreen',
	DOWNLOAD = 'download',
	NONE = 'none',
	FILTER_ONLY = 'filter-only',
}
